import orderOperate from '@/mixins/order/common/OrderOperate';

const ReconciliationChecklistMixin = {
    mixins: [orderOperate],
}
export default ReconciliationChecklistMixin
